// Lane Management KPI
export const SET_LANE_MANAGEMENT_KPI_REQUEST = 'SET_LANE_MANAGEMENT_KPI_REQUEST';
export const SET_LANE_MANAGEMENT_KPI_SUCCESS = 'SET_LANE_MANAGEMENT_KPI_SUCCESS';
export const SET_LANE_MANAGEMENT_KPI_ERROR = 'SET_LANE_MANAGEMENT_KPI_ERROR';
export const SET_LANE_MANAGEMENT_KPI_RESET = 'SET_LANE_MANAGEMENT_KPI_RESET';

// Longitudinal Motion KPI
export const SET_LONGITUDINAL_MOTION_KPI_REQUEST = 'SET_LONGITUDINAL_MOTION_KPI_REQUEST';
export const SET_LONGITUDINAL_MOTION_KPI_SUCCESS = 'SET_LONGITUDINAL_MOTION_KPI_SUCCESS';
export const SET_LONGITUDINAL_MOTION_KPI_ERROR = 'SET_LONGITUDINAL_MOTION_KPI_ERROR';
export const SET_LONGITUDINAL_MOTION_KPI_RESET = 'SET_LONGITUDINAL_MOTION_KPI_RESET';

// Safe Driving KPI
export const SET_SAFE_DRIVING_KPI_REQUEST = 'SET_SAFE_DRIVING_KPI_REQUEST';
export const SET_SAFE_DRIVING_KPI_SUCCESS = 'SET_SAFE_DRIVING_KPI_SUCCESS';
export const SET_SAFE_DRIVING_KPI_ERROR = 'SET_SAFE_DRIVING_KPI_ERROR';
export const SET_SAFE_DRIVING_KPI_RESET = 'SET_SAFE_DRIVING_KPI_RESET';

// Ego Velocity KPI
export const SET_EGO_VELOCITY_KPI_REQUEST = 'SET_EGO_VELOCITY_KPI_REQUEST';
export const SET_EGO_VELOCITY_KPI_SUCCESS = 'SET_EGO_VELOCITY_KPI_SUCCESS';
export const SET_EGO_VELOCITY_KPI_ERROR = 'SET_EGO_VELOCITY_KPI_ERROR';
export const SET_EGO_VELOCITY_KPI_RESET = 'SET_EGO_VELOCITY_KPI_RESET';

// L1 LATERAL ACCELERATION KPI
export const SET_L1_LATERAL_ACCELERATION_KPI_REQUEST = 'SET_L1_LATERAL_ACCELERATION_KPI_REQUEST';
export const SET_L1_LATERAL_ACCELERATION_KPI_SUCCESS = 'SET_L1_LATERAL_ACCELERATION_KPI_SUCCESS';
export const SET_L1_LATERAL_ACCELERATION_KPI_ERROR = 'SET_L1_LATERAL_ACCELERATION_KPI_ERROR';
export const SET_L1_LATERAL_ACCELERATION_KPI_RESET = 'SET_L1_LATERAL_ACCELERATION_KPI_RESET';

// L1 LATERAL JERK KPI
export const SET_L1_LATERAL_JERK_KPI_REQUEST = 'SET_L1_LATERAL_JERK_KPI_REQUEST';
export const SET_L1_LATERAL_JERK_KPI_SUCCESS = 'SET_L1_LATERAL_JERK_KPI_SUCCESS';
export const SET_L1_LATERAL_JERK_KPI_ERROR = 'SET_L1_LATERAL_JERK_KPI_ERROR';
export const SET_L1_LATERAL_JERK_KPI_RESET = 'SET_L1_LATERAL_JERK_KPI_RESET';

// L1 LONGITUDINAL DECELERATION KPI
export const SET_L1_LONGITUDINAL_DECELERATION_KPI_REQUEST = 'SET_L1_LONGITUDINAL_DECELERATION_KPI_REQUEST';
export const SET_L1_LONGITUDINAL_DECELERATION_KPI_SUCCESS = 'SET_L1_LONGITUDINAL_DECELERATION_KPI_SUCCESS';
export const SET_L1_LONGITUDINAL_DECELERATION_KPI_ERROR = 'SET_L1_LONGITUDINAL_DECELERATION_KPI_ERROR';
export const SET_L1_LONGITUDINAL_DECELERATION_KPI_RESET = 'SET_L1_LONGITUDINAL_DECELERATION_KPI_RESET';

// L1 LONGITUDINAL ACCELERATION KPI
export const SET_L1_LONGITUDINAL_ACCELERATION_KPI_REQUEST = 'SET_L1_LONGITUDINAL_ACCELERATION_KPI_REQUEST';
export const SET_L1_LONGITUDINAL_ACCELERATION_KPI_SUCCESS = 'SET_L1_LONGITUDINAL_ACCELERATION_KPI_SUCCESS';
export const SET_L1_LONGITUDINAL_ACCELERATION_KPI_ERROR = 'SET_L1_LONGITUDINAL_ACCELERATION_KPI_ERROR';
export const SET_L1_LONGITUDINAL_ACCELERATION_KPI_RESET = 'SET_L1_LONGITUDINAL_ACCELERATION_KPI_RESET';

// L1 LONGITUDINAL JERK KPI
export const SET_L1_LONGITUDINAL_JERK_KPI_REQUEST = 'SET_L1_LONGITUDINAL_JERK_KPI_REQUEST';
export const SET_L1_LONGITUDINAL_JERK_KPI_SUCCESS = 'SET_L1_LONGITUDINAL_JERK_KPI_SUCCESS';
export const SET_L1_LONGITUDINAL_JERK_KPI_ERROR = 'SET_L1_LONGITUDINAL_JERK_KPI_ERROR';
export const SET_L1_LONGITUDINAL_JERK_KPI_RESET = 'SET_L1_LONGITUDINAL_JERK_KPI_RESET';

// L1 LONGITUDINAL VELOCITY DROP KPI
export const SET_L1_LONGITUDINAL_VELOCITY_DROP_KPI_REQUEST = 'SET_L1_LONGITUDINAL_VELOCITY_DROP_KPI_REQUEST';
export const SET_L1_LONGITUDINAL_VELOCITY_DROP_KPI_SUCCESS = 'SET_L1_LONGITUDINAL_VELOCITY_DROP_KPI_SUCCESS';
export const SET_L1_LONGITUDINAL_VELOCITY_DROP_KPI_ERROR = 'SET_L1_LONGITUDINAL_VELOCITY_DROP_KPI_ERROR';
export const SET_L1_LONGITUDINAL_VELOCITY_DROP_KPI_RESET = 'SET_L1_LONGITUDINAL_VELOCITY_DROP_KPI_RESET';

// L0 COLLISION CHECK KPI
export const SET_L0_COLLISION_CHECK_KPI_REQUEST = 'SET_L0_COLLISION_CHECK_KPI_REQUEST';
export const SET_L0_COLLISION_CHECK_KPI_SUCCESS = 'SET_L0_COLLISION_CHECK_KPI_SUCCESS';
export const SET_L0_COLLISION_CHECK_KPI_ERROR = 'SET_L0_COLLISION_CHECK_KPI_ERROR';
export const SET_L0_COLLISION_CHECK_KPI_RESET = 'SET_L0_COLLISION_CHECK_KPI_RESET';

// L0 LATERAL SAFE DISTANCE KPI
export const SET_L0_LATERAL_SAFE_DISTANCE_KPI_REQUEST = 'SET_L0_LATERAL_SAFE_DISTANCE_KPI_REQUEST';
export const SET_L0_LATERAL_SAFE_DISTANCE_KPI_SUCCESS = 'SET_L0_LATERAL_SAFE_DISTANCE_KPI_SUCCESS';
export const SET_L0_LATERAL_SAFE_DISTANCE_KPI_ERROR = 'SET_L0_LATERAL_SAFE_DISTANCE_KPI_ERROR';
export const SET_L0_LATERAL_SAFE_DISTANCE_KPI_RESET = 'SET_L0_LATERAL_SAFE_DISTANCE_KPI_RESET';

// L0 LONGITUDINAL SAFE DISTANCE KPI
export const SET_L0_LONGITUDINAL_SAFE_DISTANCE_KPI_REQUEST = 'SET_L0_LONGITUDINAL_SAFE_DISTANCE_KPI_REQUEST';
export const SET_L0_LONGITUDINAL_SAFE_DISTANCE_KPI_SUCCESS = 'SET_L0_LONGITUDINAL_SAFE_DISTANCE_KPI_SUCCESS';
export const SET_L0_LONGITUDINAL_SAFE_DISTANCE_KPI_ERROR = 'SET_L0_LONGITUDINAL_SAFE_DISTANCE_KPI_ERROR';
export const SET_L0_LONGITUDINAL_SAFE_DISTANCE_KPI_RESET = 'SET_L0_LONGITUDINAL_SAFE_DISTANCE_KPI_RESET';

// L0 OFF ROAD CHECK KPI
export const SET_L0_OFF_ROAD_CHECK_KPI_REQUEST = 'SET_L0_OFF_ROAD_CHECK_KPI_REQUEST';
export const SET_L0_OFF_ROAD_CHECK_KPI_SUCCESS = 'SET_L0_OFF_ROAD_CHECK_KPI_SUCCESS';
export const SET_L0_OFF_ROAD_CHECK_KPI_ERROR = 'SET_L0_OFF_ROAD_CHECK_KPI_ERROR';
export const SET_L0_OFF_ROAD_CHECK_KPI_RESET = 'SET_L0_OFF_ROAD_CHECK_KPI_RESET';

// L0 LANE MARKING CHECK KPI
export const SET_L0_LANE_MARKING_CHECK_KPI_REQUEST = 'SET_L0_LANE_MARKING_CHECK_KPI_REQUEST';
export const SET_L0_LANE_MARKING_CHECK_KPI_SUCCESS = 'SET_L0_LANE_MARKING_CHECK_KPI_SUCCESS';
export const SET_L0_LANE_MARKING_CHECK_KPI_ERROR = 'SET_L0_LANE_MARKING_CHECK_KPI_ERROR';
export const SET_L0_LANE_MARKING_CHECK_KPI_RESET = 'SET_L0_LANE_MARKING_CHECK_KPI_RESET';

// L0 INDICATOR CHECKING KPI
export const SET_L0_INDICATOR_CHECKING_KPI_REQUEST = 'SET_L0_INDICATOR_CHECKING_KPI_REQUEST';
export const SET_L0_INDICATOR_CHECKING_KPI_SUCCESS = 'SET_L0_INDICATOR_CHECKING_KPI_SUCCESS';
export const SET_L0_INDICATOR_CHECKING_KPI_ERROR = 'SET_L0_INDICATOR_CHECKING_KPI_ERROR';
export const SET_L0_INDICATOR_CHECKING_KPI_RESET = 'SET_L0_INDICATOR_CHECKING_KPI_RESET';

// L0 SPEED LIMIT CHECK KPI
export const SET_L0_SPEED_LIMIT_CHECK_KPI_REQUEST = 'SET_L0_SPEED_LIMIT_CHECK_KPI_REQUEST';
export const SET_L0_SPEED_LIMIT_CHECK_KPI_SUCCESS = 'SET_L0_SPEED_LIMIT_CHECK_KPI_SUCCESS';
export const SET_L0_SPEED_LIMIT_CHECK_KPI_ERROR = 'SET_L0_SPEED_LIMIT_CHECK_KPI_ERROR';
export const SET_L0_SPEED_LIMIT_CHECK_KPI_RESET = 'SET_L0_SPEED_LIMIT_CHECK_KPI_RESET';

// L0 FALSE INDICATOR CHECK KPI
export const SET_L0_FALSE_INDICATOR_CHECK_KPI_REQUEST = 'SET_L0_FALSE_INDICATOR_CHECK_KPI_REQUEST';
export const SET_L0_FALSE_INDICATOR_CHECK_KPI_SUCCESS = 'SET_L0_FALSE_INDICATOR_CHECK_KPI_SUCCESS';
export const SET_L0_FALSE_INDICATOR_CHECK_KPI_ERROR = 'SET_L0_FALSE_INDICATOR_CHECK_KPI_ERROR';
export const SET_L0_FALSE_INDICATOR_CHECK_KPI_RESET = 'SET_L0_FALSE_INDICATOR_CHECK_KPI_RESET';

// RSS LONGITUDINAL SAFE CHECK KPI
export const SET_RSS_LONGITUDINAL_SAFE_CHECK_KPI_REQUEST = 'SET_RSS_LONGITUDINAL_SAFE_CHECK_KPI_REQUEST';
export const SET_RSS_LONGITUDINAL_SAFE_CHECK_KPI_SUCCESS = 'SET_RSS_LONGITUDINAL_SAFE_CHECK_KPI_SUCCESS';
export const SET_RSS_LONGITUDINAL_SAFE_CHECK_KPI_ERROR = 'SET_RSS_LONGITUDINAL_SAFE_CHECK_KPI_ERROR';
export const SET_RSS_LONGITUDINAL_SAFE_CHECK_KPI_RESET = 'SET_RSS_LONGITUDINAL_SAFE_CHECK_KPI_RESET';

// RSS LATERAL LEFT SAFE CHECK KPI
export const SET_RSS_LATERAL_LEFT_SAFE_CHECK_KPI_REQUEST = 'SET_RSS_LATERAL_LEFT_SAFE_CHECK_KPI_REQUEST';
export const SET_RSS_LATERAL_LEFT_SAFE_CHECK_KPI_SUCCESS = 'SET_RSS_LATERAL_LEFT_SAFE_CHECK_KPI_SUCCESS';
export const SET_RSS_LATERAL_LEFT_SAFE_CHECK_KPI_ERROR = 'SET_RSS_LATERAL_LEFT_SAFE_CHECK_KPI_ERROR';
export const SET_RSS_LATERAL_LEFT_SAFE_CHECK_KPI_RESET = 'SET_RSS_LATERAL_LEFT_SAFE_CHECK_KPI_RESET';

// RSS LATERAL RIGHT SAFE CHECK KPI
export const SET_RSS_LATERAL_RIGHT_SAFE_CHECK_KPI_REQUEST = 'SET_RSS_LATERAL_RIGHT_SAFE_CHECK_KPI_REQUEST';
export const SET_RSS_LATERAL_RIGHT_SAFE_CHECK_KPI_SUCCESS = 'SET_RSS_LATERAL_RIGHT_SAFE_CHECK_KPI_SUCCESS';
export const SET_RSS_LATERAL_RIGHT_SAFE_CHECK_KPI_ERROR = 'SET_RSS_LATERAL_RIGHT_SAFE_CHECK_KPI_ERROR';
export const SET_RSS_LATERAL_RIGHT_SAFE_CHECK_KPI_RESET = 'SET_RSS_LATERAL_RIGHT_SAFE_CHECK_KPI_RESET';